import urlParse from 'url'
import * as R from 'ramda'
import uuidv4 from 'uuid/v4'
import queryString from 'query-string'
import { universalToast } from './index'

const isJson = response => {
  if (response.status === 204) {
    return false
  }

  if (response.headers.get('content-length') === '0') {
    return false
  }

  const type = response.headers.get('content-type')
  return type && type.indexOf('application/json') !== -1
}

const isSuccess = ({ status }) => status >= 200 && status < 300

const parseError = async (status, data) => {
  const msg = R.path(['msg'], data) || '抱歉！系统繁忙，请稍后再试！'

  if (status !== 401) {
    universalToast(msg, 'fail')
  }

  return Promise.reject(data)
}

const parseUrl = (url, options) => {
  let newUrl = url
  if (typeof options.replacePrams === 'object') {
    Object.keys(options.replacePrams).forEach(i => {
      newUrl = newUrl.replace(/\{\w+\}/, () => {
        return options.replacePrams[i]
      })
    })
  }

  if (typeof options.query === 'object') {
    const urlObj = urlParse.parse(newUrl, true)
    const query = queryString.stringify(
      {
        ...urlObj.query,
        ...options.query,
      },
      { arrayFormat: 'index' }
    )
    newUrl = `${urlObj.pathname}?${query}`
  }
  return newUrl
}

const fillOptions = ({ body, ...options }) => {
  const newOptions = {
    ...options,
    mode: 'cors',
    credentials: 'include',
    headers: {
      accept: 'application/json, text/plain, */*',
      'X-Request-Id': uuidv4(),
      'X-Requested-With': 'Fetch',
    },
  }
  if (body && !(body instanceof FormData)) {
    return {
      ...newOptions,
      body: JSON.stringify(body),
      headers: {
        ...newOptions.headers,
        'Content-Type': 'application/json',
      },
    }
  } else if (body instanceof FormData) {
    return {
      ...newOptions,
      headers: newOptions.headers,
      body,
    }
  }
  return newOptions
}

export const convertToFormData = data => {
  const formData = new FormData()
  Object.keys(data).forEach(key => {
    formData.append(key, data[key])
  })
  return formData
}

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default async function request(url, options = {}) {
  // 添加默认options
  const newOptions = fillOptions(options)
  // 处理query参数
  const newUrl = parseUrl(url, options)
  const response = await fetch(newUrl, newOptions)
  const data = isJson(response) ? await response.json() : await response.text()
  const ret = {
    data: isSuccess(response) ? data : await parseError(response.status, data),
    headers: {},
  }

  if (response.headers.get('x-total-count')) {
    ret.headers['x-total-count'] = response.headers.get('x-total-count')
  }
  return ret
}



// WEBPACK FOOTER //
// ./src/utils/request.js